import { IThingie } from '../thingie/thingie';

export enum WizardStep {
  BasicSettings = 0,
  ProcessStructure,
  GeneralTaskConfiguration,
  ReplicateConfiguration,
  DeviceAssignment
}

export interface ISetupCopilotWizardPrefill {
  templateId: string;
  templateName?: string;
  experimentName?: string;
  projectId?: string;
  projectTitle?: string;
  replicateCount?: number;
  organismName?: string;
  organismClass?: 'microbial' | 'cell_culture';
  measurementGoals?: string[];
  perReplicateOverridesRequested?: boolean;
}

export interface IThingieCreationNavigationState {
  setupCopilotPrefill?: ISetupCopilotWizardPrefill;
}

export interface IWizardOptionsWithThingie {
  thingies: IThingie[];
  mode: 'EDIT' | 'DUPLICATE';
  entry?: WizardStep;
}

interface IWizardOptionsWithEntryOnly {
  mode: 'CREATE';
  entry?: WizardStep;
  setupPrefill?: ISetupCopilotWizardPrefill;
}

export type IWizardOptions = IWizardOptionsWithEntryOnly | IWizardOptionsWithThingie;

export function areWizardOptions(arg: any): arg is IWizardOptions {
  return (
    'entry' in arg
    || 'mode' in arg && (arg.mode === 'EDIT' || arg.mode === 'DUPLICATE' || arg.mode === 'CREATE')
  );
}
